module.exports = __webpack_public_path__ + "img/scanning.325fe71a.png";